import Contactsec1 from "../../components/ContactUs/Contactsec1";

const Contact = () =>{
    return(
        <Contactsec1/>
    );
}

export default Contact;